import axios from "../libs/axios";
// import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1/role/`;

class RoleService {
  getAll() {
    return axios.get(API_URL + "all");
  }
}

export default new RoleService();
